const PATH = 'fe.pages.learning_resources.educator_home_page';

const messages = {
  searchPlaceholder: {
    key: `${PATH}.search_placeholder`,
    defaultValue: 'Search All Resources'
  },
  notAllowed: {
    key: `${PATH}.not_allowed`,
    defaultValue: 'As coach, you are not allowed to view this page'
  },
  allResources: {
    key: `${PATH}.all_resources`,
    defaultValue: 'All available resources.'
  },
  recommendations: {
    key: `${PATH}.recommendations`,
    defaultValue: 'Resources assigned for my professional development.'
  },
  started: {
    key: `${PATH}.started`,
    defaultValue: 'Essential resources to help me begin my learning journey.'
  },
  important: {
    key: `${PATH}.important`,
    defaultValue: 'A collection of all resources I have marked as important.'
  },
  classroom: {
    key: `${PATH}.classroom`,
    defaultValue:
      'Personalized suggestions based on my most recent CLASS observation data.'
  },
  history: {
    key: `${PATH}.history`,
    defaultValue: "Recommendations based on resources I've recently explored."
  },
  completed: {
    key: `${PATH}.completed`,
    defaultValue: 'Archive of resources I have finished.'
  },
  noSubscription: {
    key: `${PATH}.no_subscription`,
    defaultValue:
      'You do not have access to this Learning Resources subscription.'
  }
};

export default messages;
